import { defineLocaleOverrides } from '@link/share/i18n';

/**
 * LINK-5548: the nationality label reads "country or region of residence" in
 * this app only.
 */
export default defineLocaleOverrides({
  en: { share: { profile: { country: 'Country or region of residence' } } },
  ja: { share: { profile: { country: 'お住まいの国または地域' } } },
  ko: { share: { profile: { country: '거주 국가 또는 지역' } } },
  zh: { share: { profile: { country: '居住国家或地区' } } },
  zt: { share: { profile: { country: '居住國家或地區' } } }
});
